export type TLayoutFileKind = 'docx' | 'json';

export const buildLayoutDownloadFileName = (layoutName: string, kind: TLayoutFileKind) => {
  const safeName = layoutName
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '')
    .replace(/\s+/g, ' ');
  return `${safeName || 'layout'}.${kind}`;
};
